import { Template } from '../../user/templates/template';

export abstract class TemplateRepository {
  abstract loadGroup<T>(group: string): Promise<Template<T>[]>;
  abstract create<T>(template: Template<T>): Promise<Template<T>>;
  abstract delete<T>(group: string): Promise<Template<T>>;
}
